module.exports = __webpack_public_path__ + "img/nodata1.635d2f12.png";